import React from "react";
import { useEffect, useCallback, useState } from "react";
import { Grid, Row, Col, Panel, Divider } from "rsuite";
//import EyeRoundIcon from "@rsuite/icons/EyeRound";
//import HlsPlayer from "./hls";
import "./draggable.css";
import HlsDrawerPlayer from "./HlsDrawerPlayer";

//const URL_READ_CAMERA_ITEM = process.env.REACT_APP_URL_READ_CAMERA_ITEM;

const ImagePanel = ({ header, image, detection, strtimestamp }) => (
  <Panel bordered={true} shaded header={header}>
    <Row alignItems="flex-end">
      {detection === "Supernatant" ? (
        <Col
          xs={12}
          style={{
            textAlign: "left",
            color: "blue",
            fontSize: "20px",
            fontWeight: "bold",
          }}
        >
          {detection}
        </Col>
      ) : (
        <Col
          xs={12}
          style={{
            textAlign: "left",
            color: "red",
            fontSize: "20px",
            fontWeight: "bold",
          }}
        >
          {detection}
        </Col>
      )}

      <Col xs={12} style={{ textAlign: "right" }}>
        {strtimestamp}
      </Col>
    </Row>
    <div
      style={{
        display: "flex",
        flexDirection: "column", // stack rows vertically
        alignItems: "center", // center horizontally
        justifyContent: "center", // center vertically (if div has height)
        height: "100%",
        marginBottom: 20,
      }}
    >
      <img
        className="chart-img"
        src={image}
        alt="Camera View"
        style={{ objectFit: "cover", width: "100%" }}
      />
    </div>
  </Panel>
);

function Dashboard() {
  // Live Stream Modal for Camera 1
  /*const modalTitleStream1 = useRef(null);
  const [openStream1, setOpenStream1] = useState(false);
  const handleOpenStream1 = () => {
    modalTitleStream1.current = "SSTD Camera 1 (Live)";
    setOpenStream1(true);
  };
  const handleCloseStream1 = () => setOpenStream1(false);*/

  const [image01, setImage01] = useState(null);

  const validateOperation = useCallback(async () => {
    try {
      const container = "cameras";
      const field = "_ts";
      const order = "DESC";
      const apiUrl = "/api/readCameraItem";

      const params = new URLSearchParams({ container, field, order });
      const response = await fetch(`${apiUrl}?${params.toString()}`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const retrievedDoc = await response.json(); // parse JSON body
      setImage01(retrievedDoc.resUrl);
    } catch (err) {
      console.log(JSON.stringify(err, null, 2));
    }
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      validateOperation();
    }, 1000); // Run every 1 second

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, [validateOperation]);

  return (
    <>
      <HlsDrawerPlayer src="http://localhost:4000/index.m3u8" />
      <Grid fluid style={{ marginTop: -10 }}>
        {/*<Row
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          onClick={handleOpenStream1}
        >
          <Button startIcon={<EyeRoundIcon />} appearance="primary">
            Live Stream
          </Button>
        </Row>*/}
        <Divider labelPlacement="start">SSTD Camera 01</Divider>
        <Row style={{ marginBottom: 40 }}>
          <Col xs={24} md={12}>
            {image01 && (
              <ImagePanel
                header="SSTD Discharge Outlet 1"
                image={image01}
                detection={"Supernatant"}
                strtimestamp={"14:00:00 09/12/2025"}
              />
            )}
          </Col>
        </Row>
      </Grid>
    </>
  );
}

export default Dashboard;
